import DesksAmberStateContainer from './DeskAmberStateContainer';

export default DesksAmberStateContainer;
